import { UserRound } from 'lucide-react';
import { AppLogo } from '@/components/common/AppLogo';
import { FIT_TO_SCREEN_PAGE_CLASS } from '@/components/layout/page.constants';
import { APP_NAME } from '@/constants/app.constants';
import { cn } from '@/lib/utils';
import { useAuthStore } from '@/store/auth.store';
import { RAISED_CARD_CLASS } from '@/styles/raisedCard';

export function WelcomePage() {
  const fullName = useAuthStore((state) => state.user?.fullName);

  return (
    <div className={FIT_TO_SCREEN_PAGE_CLASS}>
      <section
        className={cn(
          RAISED_CARD_CLASS,
          'flex min-h-[60vh] flex-1 items-center justify-center rounded-2xl border bg-card p-6 sm:p-10',
        )}
      >
        <div className="flex max-w-md flex-col items-center gap-5 text-center">
          <AppLogo className="size-10" />

          <div className="flex flex-col gap-2">
            <h2 className="text-2xl font-semibold tracking-tight">Welcome to {APP_NAME}</h2>
            <p className="text-sm text-muted-foreground">
              Choose a module from the sidebar to get started.
            </p>
          </div>

          {fullName ? (
            <span className="flex items-center gap-2 rounded-full border border-border/60 bg-background/60 px-3 py-1.5 text-sm font-medium shadow-sm">
              <UserRound className="size-4 text-muted-foreground" aria-hidden />
              {fullName}
            </span>
          ) : null}
        </div>
      </section>
    </div>
  );
}
